import React, { useState } from 'react';
import { Modal } from 'antd';
import { ModalProps } from 'antd/lib/modal';

import ServiceScheduleTable, {
  ServiceScheduleTableProps,
} from './ServiceScheduleTable';

export type ServiceScheduleModalProps = Pick<
  ModalProps,
  'onCancel' | 'visible'
> &
  ServiceScheduleTableProps & {
    controller?: React.ReactElement;
    flagretailer?:boolean;
  };

const ServiceScheduleModal = ({
  financialSchedule = [],
  controller,
  onCancel: onCancelProp,
  visible: visibleProp,
  currcode,
  flagretailer,
  ...otherProps
}: ServiceScheduleModalProps) => {
  const [visible, setVisible] = useState(false);

  return (<>
    {controller &&
      React.cloneElement(controller, { onClick: () => setVisible(true) })}
    <Modal
      title="Payment schedule"
      footer={null}
      width={1200}
      style={{ top: '20px', height: '400px' }}
      open={controller ? visible : visibleProp}
      onCancel={controller ? () => setVisible(false) : onCancelProp}
      {...otherProps}
    >
      <ServiceScheduleTable
        currcode={currcode}
        flagretailer={flagretailer}
        financialSchedule={financialSchedule}
      />
    </Modal>
  </>);
};

export default ServiceScheduleModal;
